<template>
  <v-app-bar flat class="header" height="150px">
    <v-col cols="12" xs="12" sm="11" md="11" lg="11" class="no-padding-col">
      <!-- pcの場合はこちらを表示 -->
      <v-row v-if="this.deviceName === 'pc'" no-gutters>
        <v-col cols="8" xs="8" sm="4" md="4" lg="4" class="no-vertical-padding-col">
          <v-btn text color="#FFFFFF" @click="logoAction">
            <v-img src="@/assets/logo.svg" class="logo-img"></v-img>
            <p class="logo">まいにちエコチェッカー</p>
          </v-btn>
        </v-col>
        <v-col cols="12" xs="12" sm="8" md="8" lg="8" class="no-vertical-padding-col">
          <v-row>
            <v-spacer></v-spacer>
            <v-col cols="6" xs="6" sm="2" md="3" lg="3" class="no-vertical-padding-col">
              <p class="date-label">{{ NowDate }}</p>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" xs="6" sm="4" md="2" lg="3" class="no-vertical-padding-col">
              <p class="user-name">
                <v-icon class="icon">mdi-account</v-icon>
                {{ userName }}
              </p>
            </v-col>
            <v-col
              cols="3"
              xs="4"
              sm="3"
              md="2"
              lg="3"
              v-if="this.deviceName === 'pc'"
              class="no-vertical-padding-col"
            >
              <v-btn text small color="#FFFFFF" class="logout" @click="logout">
                <v-icon class="icon">mdi-arrow-right-thick</v-icon>
                <p>ログアウト</p>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- spの場合はこちらを表示 -->
      <v-row v-else no-gutters>
        <v-col cols="12" class="no-vertical-padding-col">
          <v-row>
            <v-col cols="2">
              <v-img src="@/assets/logo.svg" class="logo-img" @click="logoAction"></v-img>
            </v-col>
            <v-col cols="4">
              <v-row>
                <p class="date-label">{{ NowDate }}</p>
              </v-row>
            </v-col>
            <v-col cols="6">
              <p class="user-name">
                <v-icon class="icon">mdi-account</v-icon>
                {{ userName }}
              </p>
            </v-col>
            <v-col cols="3" xs="4" sm="3" md="2" lg="3" v-if="this.deviceName === 'pc'">
              <v-btn text small color="#FFFFFF" class="logout" @click="logout">
                <v-icon class="icon">mdi-arrow-right-thick</v-icon>
                <p>ログアウト</p>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-app-bar>
</template>

<script>
export default {
  name: "Header",
  data: () => ({
    tankId: null,
    userName: "",
    userAuthority: ""
  }),
  computed: {
    deviceName() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "sp";
        case "sm":
        case "md":
        case "lg":
        case "xl":
          return "pc";
        default:
          return "pc";
      }
    },
    NowDate() {
      //日本語の曜日データを入れる配列を作成する
      let w_day = ["日", "月", "火", "水", "木", "金", "土"];
      let date = new Date();
      var day = w_day[date.getDay()];

      let shownDate =
        date.getMonth() +
        1 +
        "/" +
        date.getDate() +
        " (" +
        day +
        ")" +
        date.getHours() +
        ":" +
        date.getMinutes();

      return shownDate;
    }
  },
  mounted() {
    this.fetchInitialData();
  },
  methods: {
    fetchInitialData() {
      const user_info = this.$store.getters["user/getUserInfo"];
      this.userId = user_info.userId;
      this.userName = user_info.userName;
      this.accessToken = user_info.accessToken;
      this.userAuthority = user_info.userAuthority;
    },
    logout() {
      this.$router.push("/");
      window.localStorage.removeItem("vuex");
    },
    logoAction() {
      this.$router.push("/top");
    }
  }
};
</script>

<style scoped>
p {
  margin: 0;
  vertical-align: middle;
}
.no-padding-col {
  padding: 0;
}
.no-vertical-padding-col {
  padding-top: 0;
  padding-bottom: 0;
}
.header {
  background: transparent linear-gradient(180deg, #3c638f 0%, #74b8be 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}
.logo {
  font-family: "futurastd boldoblique";
  color: #ffffff;
  font-size: 2em;
}
.icon {
  color: #ffffff;
}
.logo-img {
  width: 50px;
}
.date-label {
  color: #ffffff;
  font-weight: Bold;
}
.user-name {
  color: #ffffff;
  font-weight: Bold;
}
.router-link {
  color: #ffffff;
}
.logout {
  font-size: 0.9em;
  font-family: YuGothic;
  font-weight: Bold;
}
.user-name {
  color: #ffffff;
}
@media screen and (max-width: 350px) {
  .logo-img {
    width: 20px;
  }
  .logo {
    font-size: 1em;
  }
  .logout {
    font-size: 0.8em;
  }
  .date-label {
    font-size: 0.8em;
  }
  .user-name {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 351px) and (max-width: 768px) {
  .logo-img {
    width: 30px;
  }
  .logo {
    font-size: 0.8em;
  }
  .date-label {
    font-size: 1.2em;
  }
  .user-name {
    font-size: 0.8em;
  }
  .logout {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .logo-img {
    width: 40px;
  }
  .logo {
    font-size: 0.8em;
  }
  .date-label {
    font-size: 1.2em;
  }
  .user-name {
    font-size: 0.8em;
  }
  .logout {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 1024px) {
  .logo-img {
    width: 40px;
  }
  .logo {
    font-size: 2em;
  }
  .date-label {
    font-size: 1.2em;
  }
  .user-name {
    font-size: 1em;
  }
  .logout {
    font-size: 1em;
  }
}
</style>
